import { useCallback } from "react";
import { getEvents } from "../../api/Events";
import { useWorkOrderStore } from "../../store/wo-order";
import useGetWorkOrder from "../useGetWorkOrder";

export default function useGetComments() {
  const setComments = useWorkOrderStore((state) => state.setWoComments);
  const { trigger } = useGetWorkOrder();

  const getComments = useCallback(
    async (woNumber: string, date?: any, time?: any) => {
      let workOrder = useWorkOrderStore.getState().getWorkOrderById(woNumber);
      if (!workOrder) {
        const woResponse = await trigger(woNumber);
        if (woResponse.status === 200) workOrder = woResponse.data;
      }
      const dateCreated = date ?? workOrder?.Events?.DateCreated;
      const timeCreated = time ?? workOrder?.Events?.TimeCreated;
      const response = await getEvents({
        comment: true,
        completion: false,
        dateCreated,
        timeCreated,
      });
      if (!response.isError) {
        const remarksPath = response.data?.Comment?.Remarks;
        setComments(woNumber, remarksPath ?? "");
      }

      return response;
    },
    [setComments]
  );

  return { getComments };
}
